import { render } from "./MaterialSelect.vue?vue&type=template&id=4397ab06&ts=true"
import script from "./MaterialSelect.vue?vue&type=script&lang=ts"
export * from "./MaterialSelect.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__